import { takeEvery, call, put, cancel } from "redux-saga/effects";
import { genericEntitySaga } from "./apiSagas.js";

import { OPERATION } from "../actions/actionConstants.js";
import { REQUEST_TYPES } from "../../constants/api.js";

import { operationsCall } from "../../services/api.js";
import { createAction } from "../actions/actionUtils.js";

// -- UTILS -- //

function getEntityTypeComplete(entityType, method) {
  switch (method) {
    case REQUEST_TYPES.GET:
      return entityType.GET_COMPLETE;
    case REQUEST_TYPES.POST:
      return entityType.POST_COMPLETE;
    case REQUEST_TYPES.PUT:
      return entityType.PUT_COMPLETE;
    case REQUEST_TYPES.DELETE:
      return entityType.DELETE_COMPLETE;
    default:
      return null;
  }
}

// -- SAGAS -- //

export function* operationSaga(action, throwOnError = false) {
  if (!action) return null;

  const { operation, success, fail } = action.actions;

  const { actionEntity, options } = operation;
  const method = operation.payload.method;

  const actionEntityComplete = getEntityTypeComplete(actionEntity, method);

  let result = null;

  try {
    result = yield call(
      genericEntitySaga,
      operationsCall,
      actionEntity,
      options,
      operation
    );

    // if we have an OK result put any success actions
    // @id here is a quick fix. May need to revisit as it'll only work with hydra entities
    if (result && (result.ok === true || result["@id"])) {
      if (success) {
        const successes = Array.isArray(success) ? success : [success];
        for (let i = 0; i < successes.length; i++) {
          yield put(successes[i]);
        }
      }
      // ALWAYS complete action unless the autoComplete is false
      if (actionEntityComplete && options.autoComplete !== false) {
        yield put(createAction(actionEntityComplete, result));
      }
    }

    // required when call is made from other sagas
    return result;
  } catch (error) {
    // if we have an error put any fail actions and abort the saga
    if (fail) {
      const failures = Array.isArray(fail) ? fail : [fail];
      for (let i = 0; i < failures.length; i++) {
        yield put(failures[i]);
      }
    }
    if (throwOnError) {
      throw error; // need to throw error or the calling sagas can't terminate
    }
    yield cancel();
  }
}

// -- WATCHERS -- //

export function* watchOperationSagas() {
  yield takeEvery(OPERATION, operationSaga);
}
